import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-[6px] border border-tertiary py-1 pl-2.5 pr-2 transition-colors -tracking-tight',
  {
    variants: {
      variant: {
        default: 'bg-background text-foreground-secondary',
        secondary: 'border-transparent bg-element text-foreground hover:bg-element-hover',
        destructive: 'bg-danger hover:bg-danger-hover text-on-danger border-0 shadow-sm',
        outline: 'text-foreground',
        pro: 'bg-[#26351D] text-brand-9 border-0 shadow-sm text-xs font-medium pl-1.5 pr-1.5 py-0.5',
        modelDefault:
          'bg-element-hover text-foreground-secondary border-0 shadow-sm text-[11px] font-semibold pl-1.5 pr-1.5 py-0.5',
        beta: 'bg-[#471F35] text-[#FF58B3] border-0 shadow-sm text-xs font-medium pl-1.5 pr-1.5 py-0.5',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
